export const bannerContent = 'p-4 z-10';
export const welcomeText = 'w-full py-30 mt-8';
export const wrapper =
  'w-full flex flex-col justify-between items-start mb-4 md:mb-0';
export const classRoomIcon = 'bg-secondary text-white';
export const businessIcon = 'bg-tertiary text';
